import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { enumData } from '@/decorators';

var AddEditModal = function (_super) {
  __extends(AddEditModal, _super);

  function AddEditModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.consumableTypeEnableEnum = [];
    _this.consumableTypeEnum = [];
    _this.formDataRule = {
      consumable_type: [{
        required: true,
        message: _this.t('请选择耗材类型')
      }],
      consumable_code: [{
        required: true,
        message: _this.t('请输入耗材编码')
      }, {
        validator: _this.validateConsumableCode,
        trigger: 'blur'
      }],
      consumable_name: [{
        required: true,
        message: _this.t('请输入耗材名称')
      }]
    };
    _this.formData = _this.initFormData();
    return _this;
  }

  AddEditModal.prototype.validateConsumableCode = function (_rule, value, callback) {
    if (!value) {
      callback();
      return;
    }

    var reg = /^[A-Za-z0-9]+$/;

    if (!reg.test(value)) {
      callback(this.t('仅支持数字和字母'));
    } else {
      callback();
    }
  };

  AddEditModal.prototype.initFormData = function (data) {
    var originData = {
      id: undefined,
      consumable_type: undefined,
      consumable_code: '',
      consumable_name: '',
      remark: ''
    };

    if (data) {
      for (var key in originData) {
        if (data.hasOwnProperty(key)) {
          originData[key] = data[key];
        }
      }
    }

    return originData;
  };

  Object.defineProperty(AddEditModal.prototype, "isEdit", {
    get: function get() {
      return !!this.formData.id;
    },
    enumerable: false,
    configurable: true
  });

  AddEditModal.prototype.handleSave = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef, validateRes;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            formDataRef = this.$refs.formDataRef;
            return [4, formDataRef.validate()];

          case 1:
            validateRes = _a.sent();

            if (!validateRes) {
              return [2];
            }

            return [4, this.$api.wrapper.addEditConsumableMaterial(this.formData)];

          case 2:
            _a.sent();

            this.handleClose();
            this.$emit('success');
            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  AddEditModal.prototype.initClearValidate = function () {
    var _this = this;

    this.$nextTick(function () {
      var formDataRef = _this.$refs.formDataRef;
      formDataRef && formDataRef.clearValidate();
    });
  };

  AddEditModal.prototype.handleVisibleChange = function () {
    if (this.visible) {
      this.formData = this.initFormData(this.rowData.data);
      this.initClearValidate();
    } else {
      this.initClearValidate();
    }
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], AddEditModal.prototype, "visible", void 0);

  __decorate([Prop({})], AddEditModal.prototype, "rowData", void 0);

  __decorate([enumData('ConsumableTypeEnableEnum')], AddEditModal.prototype, "consumableTypeEnableEnum", void 0);

  __decorate([enumData('ConsumableTypeEnum')], AddEditModal.prototype, "consumableTypeEnum", void 0);

  __decorate([Watch('visible', {
    deep: true,
    immediate: true
  })], AddEditModal.prototype, "handleVisibleChange", null);

  AddEditModal = __decorate([Component], AddEditModal);
  return AddEditModal;
}(Vue);

export default AddEditModal;